module.exports = __webpack_public_path__ + "static/media/work01.77eeaebc.jpg";